// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { Toastr, Loader, Tooltip } from "@revvsales/components";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Component Imports
import TemplateTableBody from "./TemplateTableBody";
import TemplateHeader from "../TemplateHeader";

// Service Imports
import { DocumentTemplateActions, UserActions } from "../../../actions";

// Internal Imports
import { GlobalUtils, AmplitudeUtils } from "../../../utils";
import { EVENTS, LOADING_MSG } from "../../../constants";
import { USER_ROLES } from "../../../constants/roleList";

import TemplateSearchTags from "../TemplateSearchTags/TemplateSearchTags";

// Destructuring
const { handleApiErrMsg, readDataFromLocalStorage } = GlobalUtils;
const {
  fetchAllDocumentTemplates,
  clearTemplateSearchTerm,
} = DocumentTemplateActions;
const { amplitudeLogEvent } = AmplitudeUtils;
const { initTeammatesSettingsData } = UserActions;

const ORG_TEMPLATES = "organization";

class OrgTemplates extends Component {
  state = {
    showLoader: false,
    showSearchPage: false,
  };

  componentDidMount() {
    amplitudeLogEvent(EVENTS.EVENT_NAMES.MY_TEMPLATE_VIEWED);
    this._loadDocumentTemplates();
    this.props.initTeammatesSettingsData();
  }

  _loadDocumentTemplates = () => {
    this.setState({ showLoader: true });
    this.props
      .fetchAllDocumentTemplates()
      .then(() => {
        this.setState({ showLoader: false });
      })
      .catch(error => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        this.setState({ showLoader: false });
        console.error(`OrgTemplates => componentDidMount => ${error}`);
      });
  };

  _toggleSearchPage = flag => {
    this.setState({ showSearchPage: flag });
    if (!flag) {
      this._loadDocumentTemplates();
    }
  };

  _clearSearchTerm = () => {
    const { clearTemplateSearchTerm: clearSearchTerm } = this.props;
    this._toggleSearchPage(false);
    clearSearchTerm();
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");

    if (this.state.showLoader) {
      return <Loader label={LOADING_MSG.TEMPLATES} />;
    }
    const { showSearchPage } = this.state;
    const { documentTemplates, searchTerm } = this.props;

    return (
      <div className="templatedetails-container">
        {/** HEADER SECTION */}
        <section className="templates-header">
          <TemplateHeader
            type={ORG_TEMPLATES}
            showSearchPage={showSearchPage}
            toggleSearchPage={this._toggleSearchPage}
          />
        </section>
        {/** BODY SECTION */}
        {showSearchPage ? (
          <TemplateSearchTags
            searchTerm={searchTerm}
            clearSearchTerm={this._clearSearchTerm}
          />
        ) : null}

        <section className="orgtemplates-listing-section">
          {/* Table Header */}
          <div className="templatesdetails-table-header">
            <div className="templatedetails-header-wrap">
              <div className="templatedetails-header-item  td-col-label">
                <div className="templatedetails-table-text">
                  Title
                  {/* <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="templatedetails-down-icon"
                  /> */}
                </div>
              </div>
              {CURRENT_USER.roles[0].name === USER_ROLES.ADMIN && (
                <div className="templatedetails-header-item  td-col-tag tag-usergroup">
                  <Tooltip
                    placement="right"
                    align={{
                      offset: [0, 10],
                    }}
                    mouseLeaveDelay={0}
                    overlay="Manage visibility of templates based on  user groups.">
                    <div className="templatedetails-table-text tag">
                      User groups
                    </div>
                  </Tooltip>
                </div>
              )}
              <div className="templatedetails-header-item  td-col-tag">
                <div className="templatedetails-table-text tag">
                  Tags
                  {/* <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="templatedetails-down-icon"
                  /> */}
                </div>
              </div>
              <div className="templatedetails-header-item  td-col-status">
                <div className="templatedetails-table-text">
                  Status
                  {/* <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="templatedetails-down-icon"
                  /> */}
                </div>
              </div>
              <div className="templatedetails-header-item  td-col-modifiedby">
                <div className="templatedetails-table-text">
                  Modified By
                  {/* <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="templatedetails-down-icon"
                  /> */}
                </div>
              </div>
              {/* <div className="templatedetails-add-btn">
            <div className="plusiconadd">
              <FontAwesomeIcon icon={["far", "plus"]} />
            </div>
          </div> */}
            </div>
          </div>
          {/* Table Body */}
          <div className="templatebody-scrollable">
            <TemplateTableBody
              showSearchPage={showSearchPage}
              templates={documentTemplates}
            />
          </div>
        </section>
        {/* Empty Search Results */}
        {showSearchPage && documentTemplates && !documentTemplates.length ? (
          <div className="template-search-no-results">No results found</div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({
  TemplateStore: { documentTemplates, searchTerm },
}) => ({
  documentTemplates,
  searchTerm,
});

const mapDispatchToProps = {
  fetchAllDocumentTemplates,
  clearTemplateSearchTerm,
  initTeammatesSettingsData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrgTemplates);



// WEBPACK FOOTER //
// ./src/components/TemplateV2/OrgTemplates/index.js